'use client'

import { AccountInfo, AuthenticationResult, IPublicClientApplication, SilentRequest } from "@azure/msal-browser";
import { getAPIScopes } from "authConfig";
import { getTokenExpirationTime, setTokenExpirationTime } from "./helpers";

export const getTokenAccess = async (instance: IPublicClientApplication, activeAccount: AccountInfo | null, isCallAPIService: boolean = true, isForceRefresh: boolean = false) => {
    let silentRequest: SilentRequest = {
        scopes: ["User.Read"],
        forceRefresh: isForceRefresh,
    };
    if (activeAccount === null) {
        const accounts = instance.getAllAccounts();
        activeAccount = accounts[0];
    }
    if (isCallAPIService) {
        silentRequest = {
            scopes: getAPIScopes(),
            account: activeAccount,
            forceRefresh: isForceRefresh,
        };
    }
    try {
        console.info(`${isForceRefresh ? '[Force]' : ''} Getting token silently`);
        const authResult = await instance.acquireTokenSilent(silentRequest);
        setTokenExpirationTime(authResult.expiresOn?.valueOf())
        return authResult;
    } catch (e) {
        console.error(e);
        console.error("Logout due to unable to get token silently");
        instance.clearCache({
            account: activeAccount,
        });
    }
}

export const buildRequest = async (auth: AuthenticationResult, method?: 'GET' | 'POST' | 'PUT' | 'DELETE', data?: any) => {
    const { tokenType, accessToken } = auth;
    const reqHeader = {
        method: method ?? 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": `${tokenType} ${accessToken}`
        }
    } as RequestInit;
    if (data !== undefined && data !== null) {
        return {
            ...reqHeader,
            body: JSON.stringify(data)
        }
    }
    return reqHeader;
}

export const buildMultipartFormRequest = async (auth: AuthenticationResult, formData?: any, method?: 'GET' | 'POST' | 'PUT' | 'DELETE') => {
    const { tokenType, accessToken } = auth;
    const reqHeader = {
        method: method ?? 'POST',
        headers: {
            "Authorization": `${tokenType} ${accessToken}`
        },
        body: formData
    } as RequestInit;
    return reqHeader;
}

export async function callApiServiceAsync(url: string, reqHeaders?: RequestInit) {
    const fetchResult = await fetch(url, reqHeaders).then(async (res) => {
        if (!res.ok) {
            return Promise.resolve(undefined);
        }

        if (res.headers.get('Content-Length') === '0') {
            return undefined;
        }

        try {
            // Try to parse the response as JSON
            return await res.json();
        } catch (error) {
            // Handle errors in case the JSON is invalid or malformed
            console.error('Error parsing JSON:', error);
            return undefined; // Return undefined if JSON parsing fails
        }
    });
    if (!fetchResult) {
        return;
    }
    return fetchResult;
}

export async function callDownloadApiAsync(url: string, reqHeaders?: RequestInit) {
    const response = await fetch(url, reqHeaders);
    if (!response.ok) {
        throw new Error('Failed to download the file');
    }
    return response;
}